import { Moment } from 'moment-timezone'

export interface RangeValue {
  from: Moment | null
  to: Moment | null
}

export type FilterValue = string | RangeValue | null

export type FilterKind = 'text' | 'select' | 'dateRange' | 'timeRange' | 'dateTimeRange'

export interface FilterOption {
  value: string
  label: string
}

const RANGE_KINDS: FilterKind[] = ['dateRange', 'timeRange', 'dateTimeRange']

export const isRangeKind = (kind: FilterKind): boolean => RANGE_KINDS.includes(kind)

export interface FilterField {
  id: string
  kind: FilterKind
  label: string
  fromParam?: string
  toParam?: string
  placeholder?: string
  options?: FilterOption[]
}

export type FilterValues = Record<string, FilterValue>

export const emptyRange = (): RangeValue => ({ from: null, to: null })

export const isRangeValue = (value: FilterValue): value is RangeValue =>
  value !== null && typeof value === 'object'

export const defaultValueFor = (field: FilterField): FilterValue =>
  isRangeKind(field.kind) ? emptyRange() : ''

export const emptyValues = (fields: FilterField[]): FilterValues =>
  fields.reduce<FilterValues>((acc, field) => {
    acc[field.id] = defaultValueFor(field)
    return acc
  }, {})
